import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { NavigationLink as NavigationLinkProps } from './types/types';
import { defaultLocale } from '../types/constants';

export const StyledLink = styled(Link)`
color: ${(props: any) => props.theme.linkColor};
font-family: ${(props: any) => props.theme.bodyFont};

&:hover,
&:focus {
  color: ${(props: any) => props.theme.secondaryLinkActive};
  text-decoration: underline !important;
}
`;

export const StyledAnchor = styled.a`
color: ${(props: any) => props.theme.linkColor};
font-family: ${(props: any) => props.theme.bodyFont};

&:hover,
&:focus {
  color: ${(props: any) => props.theme.secondaryLinkActive};
  text-decoration: underline !important;
}
`;

const NavigationLink = ({
  node_locale, url, displayText,
}: Partial<NavigationLinkProps>) => {
  const localePrefix = node_locale && node_locale === defaultLocale ? '' : `/${node_locale?.toLowerCase()}`;
  return (
    url?.startsWith('/')
      ? (
        <StyledLink
          to={`${localePrefix}${url}`}
          data-component-type="navLink"
          className="trk-ga nav nav__anchor"
          activeClassName="active"
        >
          {displayText}
        </StyledLink>
      )
      : (
        <StyledAnchor
          href={url}
          data-component-type="navLink"
          className="trk-ga nav nav__anchor"
        >
          {displayText}
        </StyledAnchor>
      )
  );
};

export default NavigationLink;
